<template>
  <div class="yeepayDia">
    <!-- <template v-slot:title>
      <span>{{ $t("portal.er-wei-ma") }}{{ $t("portal.zhi-fu") }}</span>
    </template> -->
    <div class="ypay-content">
      <div class="content-header">
        <p>
          <span
            >{{ $t("portal.er-wei-ma-you-xiao-qi")
            }}<span class="show-time">{{ qrCodePeriodFormat }}</span></span
          >
        </p>
        <p>
           <span v-show="propData.showAmount">
             {{ $t("portal.zhi-fu")}}<span class="show-money">￥{{
                Number(propData.payAmount).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                })
              }}</span>
           </span>
        </p>
      </div>
      <canvas ref="qr_code" id="qr_code"></canvas>
    </div>
    <img src="~~/common/assets/img/banks/paytips.png" alt="" class="paytips">
  </div>
</template>

<script>
import QRCode from "qrcode";
import moment from "moment";
export default {
  name: "yeepayDia",
  components: {},
  props: {
    propData: {
      type: Object,
      default: () => ({
        qrString: "qrCode",
        //二维码字符串
        qrCodePeriod: 0,
        payAmount: 0, //充值金额
        showAmount:false
      }),
    },
  },
  data() {
    return {
      qrCodePeriodFormat: "",
      pollingTimer:null,
      time: null
    };
  },
  created() {
  },
  beforeDestroy() {
    this.hideAdd()
    
  },
  computed: {},
  mounted() {
    if (this.propData.qrCodePeriod) {
      this.nowTime= +new Date();
      this.qrCodePeriodFormat="";
      this.setTime();
    }
   
    this.$nextTick(() => {
      QRCode.toCanvas(
        this.$refs.qr_code,
        this.propData.qrString,
        {
          width: 150,
          height: 150,
          margin: 1,
        },
        (err) =>{
          console.log(err)
        }
      );
      this.startPolling()
    })
   
  },
  methods: {
    // 开始轮询
    startPolling() {
      // 确保之前的定时器被清掉
      this.stopPolling(); 
      this.isPollingActive = true;
      this.checkPay(); // 立即开始第一次检查
    },

    // 停止轮询的统一方法
    stopPolling() {
      this.isPollingActive = false;
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    checkPay() {
      if (!this.isPollingActive) {
        return;
      }
      this.$axios
        .$post(
          `rest/store/hub/v3/payment/payResult`,
          {
            id: this.propData.id,
            pay_method: "yeepay",
            order_id: this.propData.order_id,
          },
          {
            headers: {
              showNotify: false,
            },
          }
        )
        .then(({ code, data, msg }) => {
          if (!this.isPollingActive) {
            return;
          }
          if (code !== 200) {
            this.stopPolling()
            this.hideAdd({
              type: "error",
              msg: msg,
            }); //支付失败
            return;
          }
          // 100：未支付、200：支付成功、400：支付失败
          if (data.status === "200") {
            this.stopPolling()
            this.hideAdd({
              type: "success",
              msg: data.message,
              out_trade_no: data.out_trade_no,
            }); //支付成功
          } else if (data.status === "100") {
            if (+new Date() < this.propData.qrCodePeriod) {
              //二维码如果没有过期的话，则轮询
              this.pollingTimer = setTimeout(() => {
                this.checkPay();
              }, 1000);
            }
          } else {
            this.stopPolling()
            this.hideAdd({
              type: "error",
              msg: data.message,
            }); //支付失败
          }
        });
    },
    setTime() {
      let now = this.nowTime
      let endtime = this.propData.qrCodePeriod;
      clearInterval(this.time);
      this.time = setInterval(() => {
        this.qrCodePeriodFormat = moment.utc(endtime - now ).format("HH:mm:ss");
        now += 1000;
        if (now >= endtime) {
          this.qrCodePeriodFormat = this.$t("portal.er-wei-ma-yi-guo-qi");
          clearInterval(this.time);
        }
      }, 1000);
    },
    hideAdd(data = {}) {
      this.clearIntervalTimes()
      this.$emit("hide", data);
    },
    clearIntervalTimes() {
      clearInterval(this.time);
      this.stopPolling()
    }
  },
};
</script>

<style lang="less">
.ypay-content {
  text-align: center;
  padding: 0 20px 0;
  .content-header {
    display: flex;
    justify-content: space-between;
    .show-time {
      color: red;
    }
    .show-money {
      font-size: 18px;
      color: red;
    }
  }
  #qr_code {
    margin: 10px 0;
  }
  .content-footer {
    margin: 10px 0;
  }
}
.foot-btm {
  text-align: center;
}
</style>
<style scoped>
.paytips{
  width: 100px;
  display: block;
  margin: 0 auto;
  position: relative;
  top: -13px;
}
</style>
